// extracted by mini-css-extract-plugin
module.exports = {"signUpContainer":"SignUpComponent_signUpContainer__KcDCs","signInLinkContainer":"SignUpComponent_signInLinkContainer__NnVp7"};